"use client";

import React from "react";
import { useAtom } from "jotai";
import { navigationAtom, sidebarVisibilityAtom } from "@/store";
import {
  CircleDot,
  LandPlot,
  SlidersHorizontal,
  BadgeCheck,
} from "lucide-react";
import {
  Button,
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
  Railnav,
} from "@oreme/ui";
import { SidebarEnum } from "@/types";
import { useTranslations } from "next-intl";
import Link from "next/link";

function SharedRail() {
  const t = useTranslations("global.Rail");
  const [navigation, setNavigation] = useAtom(navigationAtom);
  const [sidebar, toggleSidebar] = useAtom(sidebarVisibilityAtom);

  const handleClick = (currentNav: SidebarEnum) => {
    if (currentNav === navigation) {
      toggleSidebar();
    } else {
      toggleSidebar(true);
    }
    setNavigation(currentNav);
  };

  return (
    <Railnav>
      <div className="flex flex-col gap-2 py-2 lg:py-4">
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger asChild>
              <Button
                variant={
                  sidebar && navigation == SidebarEnum.MISSIONS
                    ? "default"
                    : "ghost"
                }
                onClick={() => handleClick(SidebarEnum.MISSIONS)}
                size="icon-lg"
                className="cursor-pointer"
              >
                <LandPlot size={20} strokeWidth={1} className="p-0 m-0" />
              </Button>
            </TooltipTrigger>
            <TooltipContent side="right">{t("missions")}</TooltipContent>
          </Tooltip>
        </TooltipProvider>
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger asChild>
              <Button
                size="icon-lg"
                variant={
                  sidebar && navigation == SidebarEnum.SITES
                    ? "default"
                    : "ghost"
                }
                onClick={() => handleClick(SidebarEnum.SITES)}
                className="cursor-pointer"
              >
                <CircleDot size={24} strokeWidth={1} className="p-0 m-0" />
              </Button>
            </TooltipTrigger>
            <TooltipContent side="right">{t("sites")}</TooltipContent>
          </Tooltip>
        </TooltipProvider>
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger asChild>
              <Button
                size="icon-lg"
                variant={
                  sidebar && navigation == SidebarEnum.SETTINGS
                    ? "default"
                    : "ghost"
                }
                onClick={() => handleClick(SidebarEnum.SETTINGS)}
                className="lg:hidden cursor-pointer"
              >
                <SlidersHorizontal
                  size={24}
                  strokeWidth={1}
                  className="p-0 m-0"
                />
              </Button>
            </TooltipTrigger>
            <TooltipContent side="right">{t("settings")}</TooltipContent>
          </Tooltip>
        </TooltipProvider>
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger asChild>
              <Button
                size="icon-lg"
                variant={
                  sidebar && navigation == SidebarEnum.SETTINGS
                    ? "default"
                    : "ghost"
                }
                asChild
              >
                <Link href="https://data.oreme.org/gpsmob/gpsmob_get_doi/doi_management">
                  <BadgeCheck size={24} strokeWidth={1} className="p-0 m-0" />
                </Link>
              </Button>
            </TooltipTrigger>
            <TooltipContent side="right">{t("datasets")}</TooltipContent>
          </Tooltip>
        </TooltipProvider>
      </div>
    </Railnav>
  );
}

export { SharedRail };
